import { useState } from "react";
import GroupButtons from "../../../Components/GroupButtons/GroupButtons";
import UserSettings from "./UserSettings/UserSettings";
import ApiSettings from "./ApiSettings/ApiSettings";

const Settings = () => {
    const [selected, setSelected] = useState(0);

    return (
        <div class="card bg-glgray-600 rounded-2xl flex-col w-full h-full px-4 py-3">
            <GroupButtons 
                setSelected={setSelected}
                selected={selected}
                buttons={[    
                    { text: "Użytkownicy" }, 
                    { text: "API" }, 
                ]}
            />
            { selected == 0 &&
                <UserSettings />
            }
            { selected == 1 &&
                <ApiSettings />
            }
        </div>
    )
}

export default Settings;